<template>
    <div id="login-page">
        <div id="login-page-content">
            <img alt="Devect" src="/img/logo.png" id="logo-login" />
            <div id="login-container" class="col-xs-6 col-sm-5 col-md-4 col-lg-3" v-if="show=='login'">
                <b-field label="Email">
                    <b-input type="email" :value="email" v-model="email"></b-input>
                </b-field>

                <b-field label="Password">
                    <b-input type="password" :value="password" v-model="password"></b-input>
                </b-field>

                <b-button @click="handleSubmit" type="is-primary">Login</b-button>
                <b-button @click="show='register'" id="goToRegister">Register</b-button>
            </div>
            <div id="register-container" class="col-xs-6 col-sm-5 col-md-4 col-lg-3" v-if="show=='register'">
                <div class="row" style="margin-bottom: 10px;">
                    <div class="col-sm-6" style="padding-right: 5px;">
                        <b-field label="First name">
                            <b-input type="text" pattern=".{2,30}" ref="name" validation-message="Must have at least 2 characters" v-model="name" required></b-input>
                        </b-field>
                    </div>
                    <div class="col-sm-6" style="padding-left: 5px;">
                        <b-field label="Last name">
                            <b-input type="text" pattern=".{2,30}" ref="last_name" validation-message="Must have at least 2 characters" v-model="last_name" required></b-input>
                        </b-field>
                    </div>
                </div>
                <b-field label="Email">
                    <b-input type="email" v-model="email" ref="email" required></b-input>
                </b-field>
                <b-field label="Password">
                    <b-input type="password" v-model="password" ref="password" required></b-input>
                </b-field>
                <b-button @click="registerUser" type="is-primary" style="width:100%;">Regístrate</b-button>
                <div class="text-center" style="margin-top: 20px; text-align: center">
                    <a @click="show='login'">Entra en Devect</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import {loginUser} from '../logic/account'
    
    export default {
        data(){
            return {
                name: "",
                last_name: "",
                phone: "",
                email: "",
                password: "",
                show: "login"
            }
        },
        components: {},
        methods: {
            changeInputValue: function(model, value){
                if(model == 'email'){
                    this.email = value
                }else{
                    if(model == 'password'){
                        this.password = value
                    }
                }
            },
            registerUser: function(){
                let _this = this;
                let isNameValid = this.$refs.name.checkHtml5Validity()
                let isLastNameValid = this.$refs.last_name.checkHtml5Validity()
                let isPaswordValid = this.$refs.password.checkHtml5Validity()
                let isEmailValid = this.$refs.email.checkHtml5Validity()

                if(!isEmailValid){
                    _this.showSuccessMsg("Email is not valid", "is-danger")
                }

                if(!isPaswordValid){
                    _this.showSuccessMsg("The password must be at least 6 characters long", "is-danger")
                }

                if(!isNameValid){
                    _this.showSuccessMsg("'First name' must have at least 2 characters", "is-danger")
                }

                if(!isLastNameValid){
                    _this.showSuccessMsg("'Last name' must have at least 2 characters", "is-danger")
                }

                if (isNameValid && isLastNameValid && isPaswordValid && isEmailValid) {
                    let payload = {
                        username: this.email,
                        email: this.email,
                        password: this.password,
                        first_name: this.name,
                        last_name: this.last_name,
                        password_confirmation: this.password
                    }

                    axios.post('https://base-api.devect.com/v1/users/signup/', payload).then(response => {
                        _this.showSuccessMsg("User created", "is-success")
                        _this.show = "login"
                    }).catch(function (error) {
                        if(error.response.status == 400 && error.response.data.hasOwnProperty('email')){
                            _this.showSuccessMsg("That email address is already in use.", "is-danger")
                        }else{
                            if(error.response.status == 400 && (error.response.data.hasOwnProperty('first_name') || error.response.data.hasOwnProperty('last_name'))){
                                _this.showSuccessMsg("'First name' and 'last name' must have at least 2 characters", "is-danger")
                            }else{
                                _this.showSuccessMsg("Something went wrong. Try again later or contact support.", "is-danger")
                            }
                        }
                    }); 
                }else{
                    _this.showSuccessMsg("All the fields are required. Try again later or contact support.", "is-danger")
                }
            },
            showSuccessMsg: function(message, msg_type){
                this.$buefy.toast.open({message: message, type: msg_type})
            },
            handleSubmit(e){
                let _this = this
                e.preventDefault()
                if (this.password.length > 0) {
                    loginUser({
                        email: this.email,
                        password: this.password
                    }).then(response => {
                        localStorage.setItem('jwt',response.data.token)
                        if(localStorage.getItem('jwt') != null){
                            this.$emit('loggedIn')
                            if(this.$route.params.nextUrl != null){
                                this.$router.push(this.$route.params.nextUrl)
                            }else{
                                this.$router.push('/')
                            }
                        }
                    }).catch(error => {
                        if(error.response.status == 400){
                            _this.showSuccessMsg("The email or password you entered is incorrect.", "is-danger");
                        }else{
                            _this.showSuccessMsg("Something is wrong. Wait a few minutes or contact support.", "is-danger");
                        }
                    });
                }
            }
        },
        mounted: function(){
            particlesJS.load('login-page', '/js/particles.json?v=3', function() {});
        }
    }
</script>

<style scoped>
    #goToRegister{
        
    }
    #login-container, #register-container{
        display: block;
        float: none;
        margin: auto;
        position: relative;
        z-index: 9;
        background: #fff;
        padding: 35px 35px;
        border-radius: 6px;
    }
    #header{display: none;}
    #logo-login{display: block; margin: 0px auto 35px auto; position: relative; z-index: 9; width: 250px;}
    #login-page{
        display: table;
        width: 100%;
        background: url(/img/map.png) #111 no-repeat!important;
        background-size: 100% !important;
        background-position: center !important;
        height: 100vh;
        margin-top: 0px !important;
    }
    #login-page-content{display: table-cell; vertical-align: middle}
</style>

<style>
    .particles-js-canvas-el{
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0px;
        left: 0px;
    }
</style>
